// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__FL+sZ","mainContent":"LoginPage_mainContent__hwRWB","footer":"LoginPage_footer__CyAHZ"};